import React from 'react';
import { FaLinkedinIn, FaTwitter, FaYoutube, FaGithub } from 'react-icons/fa';

const Footer = ({ setPage }) => {
  return (
    <footer>
      <div className="footer-background">
        <img src="/logo.png" alt="Senidek Technology" className="footer-bg-logo" />
      </div>
      <div className="footer-content">
        <div className="footer-brand">
          <div className="footer-logo-wrapper">
            <img 
              src="/logo.png" 
              alt="Senidek Technology" 
              className="footer-logo"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          </div>
          <h3>Senidek <span>Technology</span></h3>
          <p>Innovating business solutions since 2026</p>
          <div className="footer-social">
            <a href="#" className="social-icon" aria-label="LinkedIn"><FaLinkedinIn /></a>
            <a href="#" className="social-icon" aria-label="Twitter"><FaTwitter /></a>
            <a href="#" className="social-icon" aria-label="YouTube"><FaYoutube /></a>
            <a href="#" className="social-icon" aria-label="GitHub"><FaGithub /></a>
          </div>
        </div>
        <div className="footer-links">
          <div className="footer-column">
            <h4>Company</h4>
            <a onClick={() => setPage('landing')}>Home</a>
            <a onClick={() => setPage('products')}>Products</a>
            <a onClick={() => setPage('contact')}>Contact</a>
            <a href="#">Careers</a>
          </div>
          <div className="footer-column">
            <h4>Products</h4>
            <a onClick={() => setPage('products')}>Senidek SaaS</a>
            <a onClick={() => setPage('products')}>Tarik CV Builder</a>
            <a href="#">Pricing</a>
            <a href="#">Documentation</a>
          </div>
          <div className="footer-column">
            <h4>Resources</h4>
            <a href="#">Blog</a>
            <a href="#">Support</a>
            <a href="#">Community</a>
            <a href="#">Events</a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2026 Senidek Technology. All rights reserved.</p>
        <div className="footer-bottom-links">
          <a href="#">Privacy Policy</a>
          <a href="#">Terms of Service</a>
          <a href="#">Cookie Policy</a>
        </div>
      </div>

      <style>{`
        footer {
          margin-top: 48px;
          padding: 40px 0 20px;
          border-top: 2px solid var(--gray-100);
          position: relative;
          overflow: hidden;
          background: linear-gradient(180deg, white, var(--gray-50));
        }

        .footer-background {
          position: absolute;
          top: 50%;
          right: -100px;
          transform: translateY(-50%);
          width: 400px;
          height: 400px;
          opacity: 0.04;
          pointer-events: none;
        }

        .footer-bg-logo {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .footer-content {
          display: grid;
          grid-template-columns: 1.2fr 2fr;
          gap: 60px;
          padding-bottom: 32px;
          position: relative;
          z-index: 1;
        }

        .footer-brand {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }

        .footer-logo-wrapper {
          width: 64px;
          height: 64px;
          border-radius: 16px;
          overflow: hidden;
          margin-bottom: 12px;
          box-shadow: 0 4px 16px rgba(37, 99, 235, 0.2);
          background: linear-gradient(135deg, #2563eb, #7c3aed);
          transition: transform 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .footer-logo-wrapper:hover {
          transform: scale(1.06) rotate(-3deg);
        }

        .footer-logo {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .footer-brand h3 {
          font-size: 1.6rem;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .footer-brand h3 span {
          color: var(--primary);
        }

        .footer-brand p {
          color: var(--gray-500);
          font-size: 0.95rem;
          margin-bottom: 16px;
        }

        .footer-social {
          display: flex;
          gap: 12px;
        }

        .social-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: var(--gray-100);
          color: var(--gray-600);
          transition: all 0.3s ease;
          text-decoration: none;
          font-size: 1rem;
        }

        .social-icon:hover {
          background: var(--primary);
          color: white;
          transform: translateY(-3px);
          box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
        }

        .footer-links {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 40px;
        }

        .footer-column h4 {
          font-weight: 600;
          margin-bottom: 12px;
          font-size: 0.95rem;
          color: var(--gray-800);
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .footer-column a {
          display: block;
          color: var(--gray-500);
          text-decoration: none;
          padding: 4px 0;
          font-size: 0.9rem;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .footer-column a:hover {
          color: var(--primary);
          transform: translateX(4px);
        }

        .footer-bottom {
          border-top: 1px solid var(--gray-200);
          padding-top: 20px;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 12px;
          color: var(--gray-400);
          font-size: 0.85rem;
          position: relative;
          z-index: 1;
        }

        .footer-bottom-links {
          display: flex;
          gap: 24px;
        }

        .footer-bottom-links a {
          color: var(--gray-400);
          text-decoration: none;
          transition: color 0.3s ease;
        }

        .footer-bottom-links a:hover {
          color: var(--primary);
        }

        @media (max-width: 1024px) {
          .footer-content {
            grid-template-columns: 1fr;
            gap: 40px;
          }
          .footer-background {
            width: 300px;
            height: 300px;
            right: -50px;
          }
        }

        @media (max-width: 768px) {
          .footer-links {
            grid-template-columns: 1fr 1fr;
            gap: 24px;
          }
          .footer-brand {
            align-items: center;
            text-align: center;
          }
          .footer-logo-wrapper {
            width: 50px;
            height: 50px;
          }
          .footer-bottom {
            flex-direction: column;
            text-align: center;
          }
          .footer-bottom-links {
            justify-content: center;
          }
          .footer-background {
            width: 200px;
            height: 200px;
          }
        }

        @media (max-width: 480px) {
          .footer-links {
            grid-template-columns: 1fr;
          }
          .footer-logo-wrapper {
            width: 45px;
            height: 45px;
          }
          .footer-brand h3 {
            font-size: 1.3rem;
          }
          .footer-bottom-links {
            flex-direction: column;
            gap: 8px;
          }
          .footer-background {
            width: 150px;
            height: 150px;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;